<template>
	<ui-modal @toggle="$emit('toggle')">
		<Head title="Modification d'un status" />
		<form method="post" @submit.prevent="handleSubmit" class="flex flex-col gap-2">
			<ui-title textSize="big" textPosition="left" class="text-slate-700">
				<template v-slot:text>
					<p>Modifier un status</p>
				</template>
				<template v-slot:actions>
					<ui-button @click="deleteStatus" :color="'red'">
						<template v-slot:icon><i class="fas fa-trash"></i></template>
						<template v-slot:text>Supprimer</template>
					</ui-button>
				</template>
			</ui-title>

			<form-select :items="types" placeholder="Type *" @valueChange="form.type = $event" :value="form.type" class="col-span-2"> </form-select>
			<form-input placeholder="Nom *" v-model="form.name"> </form-input>
			<form-input placeholder="Slug *" v-model="form.slug"> </form-input>
			<p v-if="form.type == 'action'" class="flex items-center justify-between">
				Décompter comme une visite : <ui-toggle v-model="form.show" :icons="['fa-check', 'fa-xmark']" />
			</p>

			<form-validation-errors class="lg:col-span-2"></form-validation-errors>
			<ui-button class="col-span-2 mt-3 font-bold border-2" position="center" @click.prevent="handleSubmit()" :loading="loading">
				<template v-slot:text>Valider</template>
			</ui-button>
		</form>
	</ui-modal>
</template>

<script setup>
	import { ref, onMounted, watch } from 'vue';
	import { Head, useForm, usePage, router } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';
	import Swal from 'sweetalert2';

	const page = usePage();

	const props = defineProps({
		status: {
			type: Object,
			default: () => ({}),
		},
	});

	const emit = defineEmits(['toggle']);

	const loading = ref(false);
	const types = ref([]);

	const form = useForm({
		id: props.status?.id || null,
		name: props.status?.name || null,
		type: props.status?.type || null,
		slug: props.status?.slug || null,
		show: props.status?.show || false,
	});

	watch(
		() => form.type,
		(newType) => {
			if (newType === 'action') {
				form.show = false;
			}
		},
	);

	const handleSubmit = () => {
		loading.value = true;
		form.post(route('admin.statuses.update', form.id), {
			preserveScroll: true,
			onSuccess: () => {
				router.visit(route('admin.statuses'));
				toast.success('Status modifié avec succès !');
			},
			onFinish: () => {
				loading.value = false;
			},
		});
	};

	const deleteStatus = () => {
		Swal.fire({
			title: 'Êtes-vous sûr ?',
			text: 'Cette action est irréversible.',
			icon: 'info',
			confirmButtonText: 'Confirmer la suppression',
			showCancelButton: true,
		}).then((result) => {
			if (result.isConfirmed) {
				router.delete(route('admin.statuses.destroy', { status: props.status.id }), {
					preserveScroll: true,
					onSuccess: () => {
						toast.success('Status supprimé avec succès !');
						emit('toggle');
					},
					onError: () => {
						toast.error('Une erreur est survenue lors de la suppression du status.');
					},
				});
			}
		});
	};

	onMounted(() => {
		page.props.str.statuses.forEach((status) => {
			if (!types.value.some((e) => e.value === status.type)) {
				types.value.push({
					name: page.props.str.types[status.type],
					value: status.type,
				});
			}
		});
	});
</script>
